import {
  Gauge,
  Zap,
  Activity,
  ArrowUpDown,
  Droplets,
  Box,
  Flame,
  Cog,
  Snowflake,
} from "lucide-react";

/** @type {Record<string, import("lucide-react").LucideIcon>} */
export const VITALSIGN_ICON_BY_API_KEY = {
  cylinderUtilizationPercent: Gauge,
  hpUtilizationPercent: Zap,
  runningSpeedRpm: Activity,
  suctionPressure: ArrowUpDown,
  reportedFlow: Droplets,
  dischargePressure: ArrowUpDown,
};

/** Operating Conditions labels in display order. */
export const OPERATING_CONDITIONS_LABELS = [
  "Driver Speed",
  "Station Inlet",
  "Boost",
  "Hour Meter",
  "Fuel Gas Used",
  "SFC",
  "CO2e Emissions",
  "NOx Emissions",
  "Aux. HP Used",
];

/** Equipment Info labels in display order. */
export const EQUIPMENT_INFO_LABELS = [
  "Frame",
  "Driver",
  "Stages",
  "Throws",
  "Max HP",
  "RPM Range",
  "Rod Load Type",
  "Stroke Length",
  "Location",
  "Elevation",
];

/**
 * Flag Diagnostics accordion: order matches UI (cylinders first).
 * @type {Array<{ value: string, key: string, Icon: import("lucide-react").LucideIcon, label: string }>}
 */
export const FLAG_DIAGNOSTIC_SECTIONS = [
  { value: "cylinders", key: "cylinders", Icon: Box, label: "Cylinders" },
  { value: "engine", key: "engine", Icon: Flame, label: "Engine" },
  { value: "frame", key: "frame", Icon: Cog, label: "Frame / Mechanicals" },
  {
    value: "cooler",
    key: "cooler",
    Icon: Snowflake,
    label: "Cooler / Temperatures",
  },
];
